import { useQuery } from '@tanstack/react-query';

import { getCustomerUuid, useCustomAddressStore, usePageLayout, useStore } from '@libs/common-next';

import { type DeliveryMethodType, fetchProductTailored } from '../api';
import { TAILORED_QUERY_KEY } from './queryKey';

const ONE_MINUTE = 60 * 1000;

type UseQueryTailoredProps = {
    locale: string;
    variantSkus: string[];
    deliveryMethodsList?: DeliveryMethodType[];
};

export const useQueryTailored = ({ deliveryMethodsList, locale, variantSkus }: UseQueryTailoredProps) => {
    const { user } = usePageLayout();
    const customerUuid = getCustomerUuid(user);
    const { selectedStoreId } = useStore();

    const sddAddress = useCustomAddressStore(state => state.address);
    const hasAddressStateHydrated = useCustomAddressStore(state => state._hasHydrated);

    const queryKey = [
        TAILORED_QUERY_KEY,
        selectedStoreId,
        ...(deliveryMethodsList || []),
        variantSkus,
        locale,
        customerUuid,
        sddAddress,
    ].filter(Boolean);

    const { data, isLoading, isPending, isFetching, isError, error } = useQuery({
        queryKey,
        queryFn: () => {
            if (!deliveryMethodsList) return;

            return fetchProductTailored({
                deliveryMethodsList,
                storeId: selectedStoreId,
                customAddress: sddAddress ?? undefined,
                variantSkus,
            });
        },
        enabled: hasAddressStateHydrated && Boolean(deliveryMethodsList?.length),
        staleTime: ONE_MINUTE,
    });

    return { data, isLoading: isLoading || !hasAddressStateHydrated, isPending, isFetching, isError, error };
};
